<template>
  <div class="themPage">
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>投诉类型：</div>
          <el-select v-model="reportType" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择投诉类型">
            <el-option
                v-for="item in [{label:'实名',value:'1'},{label:'匿名',value:'2'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <div>危害种类：</div>
          <el-select v-model="infoType" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择危害种类">
            <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <div>被举报平台：</div>
          <el-select v-model="platform" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择被举报平台">
            <el-option
                v-for="item in platformOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <div>投诉状态：</div>
          <el-select v-model="reportState" size="small" style="width: 180px;margin-right: 10px" clearable placeholder="请选择投诉状态">
            <el-option
                v-for="item in [{label:'待处理',value:'1'},{label:'处理中',value:'2'},{label:'处理完成',value:'3'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button size="small" type="primary" @click="searchBtn">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
        </div>
        <el-table
            size="small"
            tooltip-effect="dark"
            ref="multipleTable"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column label="举报人" prop="real_name" align="center"></el-table-column>
          <el-table-column label="举报人电话" prop="telephone" align="center"></el-table-column>
          <el-table-column label="举报人邮箱" prop="email" align="center"></el-table-column>
          <el-table-column label="危害种类" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.info_type == '1'">政治类</div>
              <div v-else-if="scope.row.info_type == '2'">暴恐类</div>
              <div v-else-if="scope.row.info_type == '3'">诈骗类</div>
              <div v-else-if="scope.row.info_type == '4'">色情类</div>
              <div v-else-if="scope.row.info_type == '5'">低俗类</div>
              <div v-else-if="scope.row.info_type == '6'">赌博类</div>
              <div v-else-if="scope.row.info_type == '7'">侵权类</div>
              <div v-else-if="scope.row.info_type == '8'">谣言类</div>
              <div v-else>其他类</div>
            </template>
          </el-table-column>
          <el-table-column label="举报类型" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.report_type == '1' ? '实名' : '匿名' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="被举报平台" align="center">
            <template slot-scope="scope">
              <div>{{ scope.row.platform == '1' ? 'APP' : '官网' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="投诉内容" width="300" align="center">
            <template slot-scope="scope">
              <a-tooltip placement="right" trigger="click">
                <template slot="title">
                  {{scope.row.report_content}}
                </template>
                <span style="width:270px;height:40px;display: -webkit-box;-webkit-box-orient: vertical;text-overflow: ellipsis;-webkit-line-clamp: 2;overflow : hidden;">{{ scope.row.report_content }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="投诉状态" align="center">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;justify-content: center">
                <el-tag type="danger" size="small" effect="dark" v-if="scope.row.report_state == '1'">未处理</el-tag>
                <el-tag type="warning" size="small" effect="dark" v-else-if="scope.row.report_state == '2'">处理中</el-tag>
                <el-tag type="success" size="small" effect="dark" v-else>处理完成</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="scope">
              <div @click="imgBtn(scope.row.imgList)" style="color: #00A4FF;cursor: pointer" v-if="scope.row.imgList && scope.row.imgList.length">查看</div>
              <div v-else>暂无图片</div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="create_date" align="center"/>
          <el-table-column
              align="center"
              label="操作"
              width="240"
          >
            <template slot-scope="scope">
              <el-button @click="stepBtn1(scope.row.id)" v-if="scope.row.report_state == '1'" size="small" type="danger">受理</el-button>
              <el-button @click="stepBtn2(scope.row.id)" v-else-if="scope.row.report_state == '2'"  size="small" type="success">处理完成</el-button>
              <div v-else >
                <el-button @click="viewBtn(scope.row)" size="small" type="success">查看意见</el-button>
                <el-button size="small" :disabled="true" type="success">处理完成</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>

    <a-modal
        :keyboard="false"
        :visible="imgDialog"
        title="查看图片"
    >
      <div>
        <el-image v-for="(item,index) in selectImgList" :key="index"
            style="width: 100px; height: 100px;margin-right: 10px"
            :src="item" :preview-src-list="[item]">
        </el-image>
      </div>
      <template slot="footer">
        <a-button @click="imgDialog = false">关闭</a-button>
      </template>
    </a-modal>

    <a-modal
        :keyboard="false"
        :visible="optionsDialog"
        title="查看受理意见"
    >
      <div>
        {{content}}
      </div>
      <template slot="footer">
        <a-button @click="optionsDialog = false">关闭</a-button>
      </template>
    </a-modal>

    <a-modal
        :visible="dealDialog"
        cancel-text="取消"
        ok-text="确认"
        title="受理"
        width="500px"
        @cancel="dealDialog = false"
        @ok="addSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="受理意见" prop="handlingOpinions">
          <el-input v-model="ruleForm.handlingOpinions" type="textarea" :rows="5" style="width: 300px" size="small" placeholder="请输入受理意见"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 20,
      tableData: [],
      totalElements: 0,
      typeOptions:[
        {label:'政治类',value:'1'},
        {label:'暴恐类',value:'2'},
        {label:'诈骗类',value:'3'},
        {label:'色情类',value:'4'},
        {label:'低俗类',value:'5'},
        {label:'赌博类',value:'6'},
        {label:'侵权类',value:'7'},
        {label:'谣言类',value:'8'},
        {label:'其他类',value:'9'},
      ],
      platformOptions:[
        {label:'APP',value:'1'},
        {label:'官网',value:'2'},
      ],
      reportType:null,
      infoType:null,
      platform:null,
      reportState:null,
      selectImgList:[],
      imgDialog: false,
      selectId:null,
      ruleForm:{
        handlingOpinions:''
      },
      rules: {
        handlingOpinions: {required: true, message: "请输入受理意见", trigger: "blur"}
      },
      dealDialog: false,
      optionsDialog: false,
      content: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    imgBtn(imgs){
      console.log(imgs,9999)
      this.selectImgList = []
      imgs.forEach((item)=>{
        this.selectImgList.push(item.img_url)
      })
      this.imgDialog = true
    },
    viewBtn(item){
      this.content = item.handling_opinions
      this.optionsDialog = true
    },
    searchBtn() {
      this.getList();
    },
    resetBtn() {
      this.pageNum = 1
      this.reportType = null
      this.infoType = null
      this.platform = null
      this.reportState = null
      this.getList();
    },
    getList() {
      this.postAxios("/reportInfo/selReportInfo", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap:{
          reportType: this.reportType ? this.reportType : null,
          infoType: this.infoType ? this.infoType : null,
          platform: this.platform ? this.platform : null,
          reportState: this.reportState ? this.reportState : null,
        }
      }).then(res => {
        if (res.success) {
          this.tableData = res.content
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    stepBtn1(itemId){
      this.postAxios("/reportInfo/updReportInfoById", {
        id: itemId,
        reportState: '2',
        handlingOpinions: ''
      }).then(res=>{
        this.$message.success(res.message)
        this.getList()
      })
    },
    stepBtn2(itemId){
      this.selectId = itemId
      this.ruleForm.handlingOpinions = ''
      this.dealDialog = true
    },
    addSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.postAxios("/reportInfo/updReportInfoById", {
            id: this.selectId,
            reportState: '3',
            handlingOpinions: this.ruleForm.handlingOpinions
          }).then(res=>{
            this.dealDialog = false
            this.$message.success(res.message)
            this.getList()
          })
        }
      });
    },
  }
}
</script>

<style scoped>

</style>
